import { ReportColumn } from 'types';
import { useReportColumns } from '../../../../hooks';

export const useExtensionRequestsColumns = (): ReportColumn[] => {
  const {
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    extensionRequestDate,
    extensionResponseDate,
    dateConsultationRespondedTo,
    extensionRequestReason,
    extensionRequestResponse,
  } = useReportColumns();

  return [
    consultationType,
    applicationReference,
    authority,
    category,
    consultationRequestDate,
    consulteeResponseDueDate,
    extensionRequestDate,
    extensionResponseDate,
    dateConsultationRespondedTo,
    extensionRequestReason,
    extensionRequestResponse,
  ];
};
